import ConsultationRichInput from '@brands/Components/Inputs/RichTextField/RichTextField';
import { useWindowSize } from '@brands/hooks';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import React, { FC, useEffect, useMemo, useState } from 'react';
import Modal, { Styles } from 'react-modal';

import styles from './styles.module.scss';

interface AddConsultationSummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (value: string) => Promise<void>;
  initialValue?: string;
}

const AddConsultationSummaryModal: FC<AddConsultationSummaryModalProps> = ({
  isOpen,
  onClose,
  onSave,
  initialValue = '',
}) => {
  const { width } = useWindowSize();
  const isMobile = useMemo(() => width < 768, [width]);

  const [value, setValue] = useState(initialValue || '');
  const isEditMode = Boolean(initialValue?.trim());

  useEffect(() => {
    if (!isOpen) return;
    setValue(initialValue || '');
  }, [isOpen, initialValue]);

  const modalStyles: Styles = isMobile
    ? {
        ...customStylesDashboard,
        overlay: {
          ...(customStylesDashboard.overlay || {}),
          overflowY: 'auto',
        },
        content: {
          ...(customStylesDashboard.content || {}),
          width: '100vw',
          height: '100vh',
          borderRadius: 0,
          padding: '90px 16px 32px 16px',
        },
      }
    : {
        ...customStylesDashboard,
        content: {
          ...customStylesDashboard.content,
          width: '444px',
          padding: '30px 32px 32px',
          maxHeight: '750px',
        },
      };

  const handleSave = async (): Promise<void> => {
    await onSave(value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={modalStyles}
      contentLabel="Add Consultation Summary"
      ariaHideApp={false}
    >
      <div className={styles.AddConsultationSummaryModal}>
        <div className={styles.bodyHead}>
          <CloseIcon onClick={onClose} />
        </div>

        <div className={`${styles.body} ${styles.formContainer}`}>
          <span className={styles.bodyHeader}>
            {isEditMode ? 'Edit consultation summary' : 'Add consultation summary'}
          </span>

          <div className={styles.bodySub}>
            <ConsultationRichInput
              value={value}
              editable
              onChange={(html) => setValue(html)}
              placeholder="Add consultation summary here"
              className={`fs-exclude ${styles.consultationSummaryInput}`}
            />
          </div>
        </div>

        <div className={styles.bodyFooter}>
          <Button variant="contained" className={styles.containedBtn} onClick={handleSave}>
            {isEditMode ? 'Save changes' : 'Add consultation summary'}
          </Button>

          <Button variant="text" className={styles.textBtn} onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddConsultationSummaryModal;